export const VERSION=23;
export const BUILD_DATE='2026-04-25 19:45:30';